
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rozhodci",
      function () {
        return require("private-next-pages/rozhodci/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rozhodci"])
      });
    }
  